import { render } from "./addModuleGoodsManage.vue?vue&type=template&id=16987c46&scoped=true"
import script from "./addModuleGoodsManage.vue?vue&type=script&lang=js"
export * from "./addModuleGoodsManage.vue?vue&type=script&lang=js"

import "./addModuleGoodsManage.vue?vue&type=style&index=0&id=16987c46&lang=scss&scoped=true"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16987c46"]])

export default __exports__